export default __webpack_public_path__ + "static/media/gf.f8adb485.svg";